import React from "react";
import { Helmet } from "react-helmet";

import { SITE_URL } from "utils/url";

const DEFAULT_TITLE = "SingleStore Documentation";
const DEFAULT_DESCRIPTION =
    "SingleStore is a modern relational database for cloud and on-premises that delivers immediate insights for modern applications and analytical systems. Book a demo or trial today!";
const DEFAULT_OG_IMAGE = "/images/og-image.png";
const TWITTER_USERNAME = "@SingleStoreDB";

type SEOTagsProps = {
    baseTitle?: string;
    title?: string;
    description?: string;
};

export function SEOTags({
    baseTitle = DEFAULT_TITLE,
    title,
    description = DEFAULT_DESCRIPTION,
    children,
}: React.PropsWithChildren<SEOTagsProps>) {
    const fullTitle = [title, baseTitle].filter(Boolean).join(" · ");

    let metaDescriptionToRender;
    if (description !== DEFAULT_DESCRIPTION) {
        metaDescriptionToRender = (
            <meta name="description" content={description} />
        );
    }

    return (
        <Helmet>
            <title>{fullTitle}</title>
            {metaDescriptionToRender}

            <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
            <meta charSet="utf-8" />

            <meta property="og:url" content={SITE_URL} />
            <meta property="og:type" content="website" />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={DEFAULT_OG_IMAGE} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />

            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:domain" content="docs.singlestore.com" />
            <meta property="twitter:url" content={SITE_URL} />
            <meta property="twitter:title" content={fullTitle} />
            <meta property="twitter:description" content={description} />
            <meta property="twitter:image" content={DEFAULT_OG_IMAGE} />
            <meta property="twitter:creator" content={TWITTER_USERNAME} />

            <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
            <meta
                name="viewport"
                content="width=device-width, initial-scale=1.0"
            />
            <link
                rel="shortcut icon"
                href="/images/favicon/favicon.ico"
                type="image/x-icon"
            />
            <link
                rel="apple-touch-icon"
                href="/images/favicon/apple-touch-icon.png"
                sizes="180x180"
            />
            <link
                rel="icon"
                href="/images/favicon/favicon-32x32.png"
                sizes="32x32"
                type="image/png"
            />
            <link
                rel="icon"
                href="/images/favicon/favicon-16x16.png"
                sizes="16x16"
                type="image/png"
            />
            <meta
                name="google-site-verification"
                content="WC0xNzwn7LVoSwf3TnPurxnJWU56ah_tylrzKcBW-cQ"
            />
            {children}
        </Helmet>
    );
}
